<template>
    <div class="courseProposalWrapper">
        <form id="courseProposalForm" class="feedback" :class="{hidden: status === 'thanks'}">
            <section
                style="margin: 0 auto 50px auto;"
                v-html="intro"
            />

            <label class="fullWidth" id="term"><span>Term *</span></label>
            <fieldset class="underFullWidth inputGroup" style="margin-bottom: 15px;">
                <div
                    v-for="term in terms"
                    class="customRadio"
                >
                    <asc-radio
                        v-model="$v.form.term.$model"
                        name="term"
                        :id="'term_' + term.pubid"
                        label=""
                        style="width: 30px;"
                        :value-attr="term.pubid"
                    />
                    <div class="customRadioLabel">
                        {{ term.tName }} ({{ term.dateRangeString }})
                        <span class="termDue">
                            Proposals due {{ term.dateProposalDueString }}
                        </span>
                    </div>
                </div>
                <p
                    v-if="$v.form.term.$error"
                    v-text="'Select a term.'"
                    class="help is-danger"
                />
            </fieldset>

            <label-input
                label="Instructor's name"
                id="instructor_name"
                v-model="$v.form.instructor_name.$model"
                :validator="$v.form.instructor_name"
                error-message="Instructor name is required."
            />

            <label-input
                type="textarea"
                label="Course title"
                id="course_title"
                v-model="$v.form.course_title.$model"
                :validator="$v.form.course_title"
                error-message="Course title is required."
            />
    <!--        <div class="clearfix"></div>-->

            <h3>Instructor information</h3>
            <fieldset style="margin-left: 0;" class="inputGroup">
                <label-input
                    label="Mailing address"
                    id="contact.street"
                    v-model="$v.form.contact.street.$model"
                    :required="true"
                />
                <label-input
                    label="City"
                    id="contact.city"
                    v-model="$v.form.contact.city.$model"
                    :required="true"
                />
                <label-input
                    type="custom"
                    label="State / ZIP"
                    :required="true"
                    field-body-style="display: block;"
                >
                    <template v-slot:custom>
                        <input-only
                            v-model="$v.form.contact.state.$model"
                            id="contact.state"
                            :validator="$v.form.contact.state"
                            control-style="width: 3em;"
                            :input-class="['state']"
                        />
                        <input-only
                            v-model="$v.form.contact.zip.$model"
                            id="contact.zip"
                            :validator="$v.form.contact.zip"
                            control-style="width: 6em; margin-left: 1em;"
                            :input-class="['zip']"
                        />
                    </template>
                </label-input>

                <label-input
                    label="Phone number"
                    id="contact.phone_number"
                    v-model="$v.form.contact.phone_number.$model"
                    :required="true"
                />
                <label-input
                    label="Email address"
                    id="contact.email_address"
                    v-model="$v.form.contact.email_address.$model"
                    :required="true"
                />
            </fieldset>
            <label-input
                type="custom"
                v-if="$v.form.contact.$anyDirty && $v.form.contact.$anyError"
                label=" "
            >
                <template v-slot:custom>
                    <p
                        class="help is-danger"
                        v-text="'All contact information is required.'"
                    />
                </template>
            </label-input>
            <div class="clearfix"></div>
            <label class="fullWidth">
                <span>
                    Biographical summary (including relevant education, teaching experience, and experience with the proposed
                    course subject). This section must be completed&mdash;do not ask to use previously submitted biographical summaries. *
                </span>
    <!--            <textarea v-model="$v.form.biographical_summary.$model" />-->
                <input-only
                    type="textarea"
                    id="biographical_summary"
                    v-model="$v.form.biographical_summary.$model"
                    :validator="$v.form.biographical_summary"
                    error-message="Biographical summary is required."
                    maxlength="1500"
                    :show-chars-remaining="true"
                />
            </label>

            <div class="clearfix"></div>
            <h3>Course details</h3>

            <label class="fullWidth">
                <span>
                    Course description as you would like it to appear in course brochure (may be edited for length.)
                    Provide one or two paragraphs describing the course topics and class format, and describe any specific
                    physical agility requirements, if any. *
                </span>
    <!--            <textarea v-model="$v.form.course_description.$model" />-->
                <input-only
                    type="textarea"
                    id="course_description"
                    v-model="$v.form.course_description.$model"
                    :validator="$v.form.course_description"
                    error-message="Course description is required."
                    :maxlength="1500"
                    :show-chars-remaining="true"
                />
            </label>

            <label class="fullWidth">
            <span>
                Will the course have any inherent risks outside of normal classroom activities (field trips, hiking,
                meeting outside, cooking, using tools or hazardous materials, etc.) that may require students to
                sign a Release and Assumption of Risk form? If yes, please describe them here. (An ASC admin will
                make the final determination as to whether a risk form is required.)
            </span>
<!--                <textarea v-model="$v.form.risks.$model" />-->
                <input-only
                    type="textarea"
                    v-model="$v.form.risks.$model"
                />
            </label>

            <label class="detached">
                <span>
                    Format *<br>
                    <span style="font-size: 80%; font-style: italic;">(check all that apply)</span><br>
                </span>
            </label>
            <fieldset id="format" class="inputGroup">
                <asc-checkbox
                    v-model="$v.form.format.small_group_discussion.$model"
                    id="format.small_group_discussion"
                    label="Small group discussion"
                    :disabled="onlineOnly"
                />
                <asc-checkbox
                    v-model="$v.form.format.lecture.$model"
                    id="format.lecture"
                    label="Lecture"
                    :disabled="onlineOnly"
                />
                <asc-checkbox
                    v-model="$v.form.format.presentation_discussion.$model"
                    id="format.presentation_discussion"
                    label="Presentation / discussion"
                    :disabled="onlineOnly"
                />
<!--
                <asc-checkbox
                    v-model="$v.form.format.online.$model"
                    id="format.online"
                    label="Online Zoom class"
                />
-->
<!--
                <asc-checkbox
                    v-model="$v.form.format.part_online.$model"
                    id="format.part_online"
                    label="Online and in-person sessions (combination)"
                    :disabled="onlineOnly"
                />
-->
                <asc-checkbox
                    v-model="$v.form.format.outdoor.$model"
                    id="format.outdoor"
                    label="Field Work/Outdoor Class (e.g., Birding, Geology)"
                    :disabled="onlineOnly"
                />
                <asc-checkbox
                    v-model="$v.form.format.other.$model"
                    id="format.other"
                    label="Other (e.g., workshop)"
                    :disabled="onlineOnly"
                />
                <p
                    v-if="$v.form.format.$anyError"
                    class="help is-danger"
                    v-text="'Choose at least one format.'"
                />
            </fieldset>
            <div class="clearfix"></div>

            <template v-if="!onlineOnly">
            <label class="detached">
                <span>
                    In-person / Zoom *<br>
                    <span style="font-size: 80%; font-style: italic;">(check one)</span><br>
                </span>
            </label>
            <fieldset id="presence_mode" class="inputGroup">
                <asc-radio
                    v-model="$v.form.presence_mode.$model"
                    name="presence_mode"
                    id="presence_mode_in_person"
                    label="In-person class only"
                    style="display: block;"
                    value-attr="in_person"

                />
                <asc-radio
                    v-model="$v.form.presence_mode.$model"
                    name="presence_mode"
                    id="presence_mode_online"
                    label="Online Zoom class only"
                    style="display: block;"
                    value-attr="online"

                />
                <asc-radio
                    v-model="$v.form.presence_mode.$model"
                    name="presence_mode"
                    id="presence_mode_hybrid"
                    label="In-person and online Zoom class (hybrid)"
                    style="display: block;"
                    value-attr="hybrid"

                />
                <p
                    v-if="$v.form.presence_mode.$error"
                    class="help is-danger"
                    v-text="'Response is required.'"
                />
            </fieldset>
            <div class="clearfix"></div>
            </template>

            <label
                class="fullWidth"
                id="format.description"
                v-if="form.format.other"
            >
                <span>Please describe the course format</span>
<!--                <textarea id="format_description" v-model="$v.form.format_description.$model" />-->
                <input-only
                    type="textarea"
                    v-model="$v.form.format_description.$model"
                />

            </label>

            <div class="clearfix"></div>

            <template v-if="!form.format.outdoor">
            <label class="detached">
                <span style="width: auto; margin-right: 1em;">Will the course include field work? *</span>
            </label>
            <fieldset class="inputGroup" id="field_work">
                <asc-radio
                    v-model="$v.form.field_work.$model"
                    name="field_work"
                    id="field_work_yes"
                    label="Yes"
                    :value-attr="true"
                    @input="field_work_user = $event"
                />
                <asc-radio
                    v-model="$v.form.field_work.$model"
                    name="field_work"
                    id="field_work_no"
                    label="No"
                    :value-attr="false"
                    @input="field_work_user = $event"
                />
                <p
                    v-if="$v.form.field_work.$error"
                    class="help is-danger"
                    v-text="'Field work response is required.'"
                />
            </fieldset>
            </template>

            <label-input
                v-if="form.field_work"
                type="textarea"
                id="field_trip_details"
                label="Field trip details (note that ASC does not defray travel expenses)"
                :label-class="['fullWidth']"
                v-model="$v.form.field_trip_details.$model"
                :validator="$v.form.field_trip_details"
                error-message="Field trip details are required."
                field-body-style="margin-left: 0.9em;"
            />

            <div class="clearfix"></div>

            <label class="fullWidth">
                <span>
                    Number of students (<template v-if="form.presence_mode === 'hybrid'">total is </template>typically
                    between 5 and 30 depending on class format, selected class sites, and instructor comfort level) *
                </span>
            </label>

            <template v-if="form.presence_mode !== 'online'">
            <label class="detached" style="margin-left: 32px;">
                <span style="width: auto; margin-right: 1em;">In-person section</span>
            </label>
            <fieldset class="inputGroup">
                <span>Min</span> <input type="number" v-model="$v.form.in_person_min.$model" min="1" :max="form.in_person_max || ''">
                <span>Max</span> <input type="number" v-model="$v.form.in_person_max.$model" :min="form.in_person_min || 1">
            </fieldset>
            <div class="clearfix"></div>
            </template>

            <template v-if="form.presence_mode !== 'in_person'">
            <label class="detached" style="margin-left: 32px;">
                <span style="width: auto; margin-right: 1em;">Online Zoom section</span>
            </label>
            <fieldset class="inputGroup">
                <span>Min</span> <input type="number" v-model="$v.form.online_min.$model" min="1" :max="form.online_max || ''">
                <span>Max</span> <input type="number" v-model="$v.form.online_max.$model" :min="form.online_min || 1">
            </fieldset>
            <div class="clearfix"></div>
            </template>

            <p
                v-if="$v.form.in_person_min.$error || $v.form.in_person_max.$error || $v.form.online_min.$error || $v.form.online_max.$error"
                class="help is-danger"
                v-text="'Number of students is required.'"
                style="margin-left: 2em;"
            />

            <br>

            <label class="detached">
                <span style="width: auto; margin-right: 1em;">Will the course be team taught?</span>
            </label>
            <fieldset class="associated inputGroup" id="other_instructors">
                <asc-radio
                    v-model="$v.form.other_instructors.$model"
                    name="other_instructors"
                    id="other_instructors_yes"
                    label="Yes"
                    :value-attr="true"
                />
                <asc-radio
                    v-model="$v.form.other_instructors.$model"
                    name="other_instructors"
                    id="other_instructors_no"
                    label="No"
                    :value-attr="false"
                />
                <p
                    v-if="$v.form.other_instructors.$error"
                    class="help is-danger"
                    v-text="'Team teaching response is required.'"
                />
            </fieldset>

            <label-input
                v-if="form.other_instructors"
                type="textarea"
                id="other_instructor_detail"
                label="Who else will be teaching?"
                :label-class="['fullWidth']"
                v-model="$v.form.other_instructor_detail.$model"
                :validator="$v.form.other_instructor_detail"
                error-message="Other instructor details are required."
                field-body-style="margin-left: 0.9em;"
            />

            <div class="clearfix"></div>
            <h3>Logistical information</h3>
            <label class="fullWidth" style="margin-bottom: 15px;">
                <span>
                    Classes usually run from 4 to 8 weeks, and typically meet once a week for 2 hours.
                    If you prefer a different schedule, please describe in the <i>Alternate days/times</i> box below.
                </span>
            </label>
            <fieldset id="dates" style="margin-left: 0;" class="inputGroup">
                <label style="display: inline-block;"><span>Number of weeks *</span>
                    <select id="number_of_weeks" v-model="$v.form.number_of_weeks.$model" class="datesGroup.$model">
                        <option value=""></option>
                        <option value="4">4</option>
                        <option value="5">5</option>
                        <option value="6">6</option>
                        <option value="7">7</option>
                        <option value="8">8</option>
                    </select></label>
                <label style="display: inline-block;">Starting week of *
                    <input type="date" id="date_start" v-model="$v.form.date_start.$model" placeholder="mm/dd/yyyy" class="datesGroup.$model">
                </label>
                <div class="clearfix"></div>
<!--
                <label class="detached"><span style="width: auto; margin-right: 1em;">Class frequency *</span></label>
                <fieldset class="associated inputGroup" id="days_per_week">
                    <asc-radio
                        v-model="$v.form.days_per_week.$model"
                        name="days_per_week"
                        id="days_per_week_1"
                        label="1 x week"
                        value-attr="1"
                    />
                    <asc-radio
                        v-model="$v.form.days_per_week.$model"
                        name="days_per_week"
                        id="days_per_week_2"
                        label="2 x week"
                        value-attr="2"
                    />
                </fieldset>
-->
<!--                v-if="$v.form.number_of_weeks.$error || $v.form.date_start.$error || $v.form.days_per_week.$error"-->
                <p
                    v-if="$v.form.number_of_weeks.$error || $v.form.date_start.$error"
                    class="help is-danger"
                    v-text="'All scheduling details required.'"
                    style="margin-left: 1.5em;"
                />
            </fieldset>


            <hr style="width: 96%;">

            <label class="fullWidth">
                <span>
                    Days/times preferred. Rank your choices below, from most preferred (1) to least preferred (10).
                    Please select at least 3 choices. You can propose alternate days & times in the box below.
                    (Standard choices are still required.) *
                </span>
            </label>
            <fieldset class="underFullWidth inputGroup" v-if="form.day_time_ranks">
                <table class="days_times wide">
                    <tr>
                        <th>&nbsp;</th>
                        <th v-for="day in days" v-text="day" />
                    </tr>
                    <tr v-for="(timeSlot, iTimeSlot) in timeSlots">
                        <th v-text="timeSlot" />
                        <td v-for="(day, iDay) in days">
                            <input
                                :key="'day_time_rank_' + iDay + '_' + iTimeSlot"
                                type="text"
                                v-model="$v.form.day_time_ranks.$model[iDay][iTimeSlot]"
                                maxlength="2"
                                @keydown="enforceDigitsOnly"
                                @input="updateDayTimeRanks(iDay, iTimeSlot)"
                                :class="day_time_rank_classes[iDay][iTimeSlot]"
                            >
                        </td>
                    </tr>
                </table>
                <table class="days_times narrow">
                    <tr>
                        <th>&nbsp;</th>
                        <th v-for="timeSlot in timeSlots" v-text="timeSlot" style="padding: 0 1em" />
                    </tr>
                    <tr v-for="(day, iDay) in days">
                        <th v-text="day" />
                        <td v-for="(timeSlot, iTimeSlot) in timeSlots" style="text-align: center;">
                            <input
                                :key="'day_time_rank_' + iDay + '_' + iTimeSlot"
                                type="text"
                                v-model="$v.form.day_time_ranks.$model[iDay][iTimeSlot]"
                                maxlength="2"
                                @keydown="enforceDigitsOnly"
                                @input="updateDayTimeRanks(iDay, iTimeSlot)"
                                :class="day_time_rank_classes[iDay][iTimeSlot]"
                            >
                        </td>
                    </tr>
                </table>

                <p
                    v-if="$v.form.day_time_ranks.$error || $v.form.times_notes.$error"
                    class="help is-danger"
                    v-text="'Rank at least 3 day/time choices (above) or describe preferred times (below).'"
                    style="margin-left: 0.2em;"
                />
            </fieldset>

            <label class="fullWidth">
                <span>
                    Alternate days/times: online classes, evening, or weekend proposals may be scheduled at more flexible times.
                    Please indicate your preferred times here.
                </span>
<!--                <textarea id="times_notes" v-model="$v.form.times_notes.$model" />-->
                <input-only
                    type="textarea"
                    v-model="$v.form.times_notes.$model"
                />
            </label>

            <div class="clearfix"></div>

            <hr style="width: 96%;">

            <div
                id="locationsWrapper"
                v-if="showLocations"
            >
                <label class="fullWidth" id="locations">
                    <span>
                        <b>Locations preferred.</b> Rank your choices below, with 1 being best. Give at least
                        {{ nClassroomSelectionsRequired }} choice{{ nClassroomSelectionsRequired === 1 ? '' : 's'}}. *
                        <br>
                        Please note that site restrictions and overlapping requests may impact class size and scheduling times.
                        It is important that instructors visit the sites before selecting them.
                    </span>
                </label>
<!--                <pre>{{ form.classroom_ranks }}</pre>-->
                <p
                    v-if="$v.form.classroom_ranks.$error"
                    class="help is-danger"
                    v-text="`Rank at least ${nClassroomSelectionsRequired} classroom choice${ nClassroomSelectionsRequired === 1 ? '' : 's'} below.`"
                    style="margin-left: 1.5em;"
                />
                <fieldset class="inputGroup">
                    <template v-for="cr in classroomRegionsToShow">
                        <h4 v-text="cr.rName" />
                        <div v-for="classroom in cr.classrooms">
                            <input
                                :key="'classroom_rank_' + classroom.pubid"
                                type="text"
                                v-model="$v.form.classroom_ranks.$model[classroom.pubid]"
                                maxlength="2"
                                @keydown="enforceDigitsOnly"
                                @input="updateClassroomRanks(classroom.pubid)"
                                :class="classroom_rank_classes[classroom.pubid]"
                                style="width: 2.5em;"
                            >
                            {{ classroom.cName }}
                            <span v-if="classroom.notes"> ({{ classroom.notes }})</span>
                            <sup v-if="classroom.evening">1</sup>
                        </div>
                    </template>

                    <p><sup>1</sup> These sites may be available for evening classes.</p>
                    <p>
                        Note: All sites are handicap accessible. Some rooms may require that tables and/or chairs be set up
                        and taken down by instructors and class members.
                        After evening classes, the instructor will be responsible for locking up.
                    </p>
                </fieldset>
            </div>


            <h3>Course requirements</h3>

            <label-input
                type="textarea"
                id="supplies"
                label="List supplies you will need (e.g., paper, paints)"
                v-model="$v.form.supplies.$model"
            />

            <div class="clearfix"></div>

            <label class="detached"><span>Will you use a required text? *</span></label>
            <fieldset class="associated inputGroup" id="required_text">
                <asc-radio
                    v-model="$v.form.required_text.$model"
                    name="required_text"
                    id="required_text_yes"
                    label="Yes"
                    :value-attr="true"
                />
                <asc-radio
                    v-model="$v.form.required_text.$model"
                    name="required_text"
                    id="required_text_no"
                    label="No"
                    :value-attr="false"
                />
                <p
                    v-if="$v.form.required_text.$error"
                    class="help is-danger"
                    v-text="'Response is required.'"
                />
            </fieldset>

            <fieldset id="required_text_details" v-if="form.required_text">
                <label class="fullWidth"><span>I have checked with Sherman&apos;s Bookstore (288-3161) and they have assured me that this text can be made available by the time my class starts</span></label>
                <fieldset class="inputGroup associated" id="checked_shermans">
                    <asc-radio
                        v-model="$v.form.checked_shermans.$model"
                        name="checked_shermans"
                        id="checked_shermans_yes"
                        label="Yes"
                        :value-attr="true"
                    />
                    <asc-radio
                        v-model="$v.form.checked_shermans.$model"
                        name="checked_shermans"
                        id="checked_shermans_no"
                        label="No"
                        :value-attr="false"
                    />
                    <p
                        v-if="$v.form.checked_shermans.$error"
                        class="help is-danger"
                        v-text="'Response is required.'"
                    />
                </fieldset>

                <fieldset class="book_detail" v-for="book in form.books" id="book_detail">
                    <label><span>Author</span><input type="text" v-model="book.author" class="user-success"></label>
                    <label><span>Title</span><input type="text" v-model="book.title" class="user-success"></label>
                    <label><span>Publisher</span><input type="text" v-model="book.publisher" class="user-success"></label>
                    <label><span>Publication date</span><input type="text" v-model="book.date" class="user-success"></label>
                    <label><span>ISBN</span><input type="text" v-model="book.isbn" class="user-success"></label>
                </fieldset>
                <i class="icon-add" @click="addBook" style="margin-left: 2em;"> Add a text</i>
            </fieldset>

            <label class="fullWidth">
                <span>
                    Please estimate the cost of text and/or supplies for your course (per person):
                    <input-only
                        id="materials_cost"
                        v-model="$v.form.materials_cost.$model"
                        :validator="$v.form.materials_cost"
                        error-message="Materials cost is required."
                    />
                </span>
            </label>

            <div class="clearfix"></div>

            <label class="fullWidth"><span>Will you need materials scanned or photocopied? *</span></label>
            <fieldset class="inputGroup associated" id="need_copies">
                <asc-radio
                    v-model="$v.form.need_copies.$model"
                    name="need_copies"
                    id="need_copies_yes"
                    label="Yes"
                    :value-attr="true"
                />
                <asc-radio
                    v-model="$v.form.need_copies.$model"
                    name="need_copies"
                    id="need_copies_no"
                    label="No"
                    :value-attr="false"
                />
                <p
                    v-if="$v.form.need_copies.$error"
                    class="help is-danger"
                    v-text="'Response is required.'"
                />
            </fieldset>

            <div id="equipmentNeedsWrapper">
                <label class="fullWidth"><span>Equipment needs (check items you will need):</span></label>
                <fieldset style="clear: left; margin-left: 2em;">
<!--
                    <asc-checkbox
                        v-model="$v.form.equipment.slide_projector.$model"
                        id="equipment.slide_projector"
                        label="Slide projector / screen"
                        :disabled="onlineOnly"
                    />
-->
<!--
                    <asc-checkbox
                        v-model="$v.form.equipment.overhead_projector.$model"
                        id="equipment.overhead_projector"
                        label="Overhead projector / screen"
                        :disabled="onlineOnly"
                    />
-->
                    <asc-checkbox
                        v-model="$v.form.equipment.flip_chart.$model"
                        id="equipment.flip_chart"
                        label="Flip chart / colored pens"
                        :disabled="onlineOnly"
                    />
                    <asc-checkbox
                        v-model="$v.form.equipment.lcd_projector.$model"
                        id="equipment.lcd_projector"
                        label="LCD projector / screen (requires laptop)"
                        :disabled="onlineOnly"
                    />
                    <asc-checkbox
                        v-model="$v.form.equipment.cd_player.$model"
                        id="equipment.cd_player"
                        label="CD player"
                        :disabled="onlineOnly"
                    />
                    <asc-checkbox
                        v-model="$v.form.equipment.dvd_player.$model"
                        id="equipment.dvd_player"
                        label="DVD player"
                        :disabled="onlineOnly"
                    />
                    <asc-checkbox
                        v-model="$v.form.equipment.other.$model"
                        id="equipment.other"
                        label="Other"
                        :disabled="onlineOnly"
                    />
                </fieldset>
                <label-input
                    v-if="form.equipment.other"
                    type="textarea"
                    id="equipment_other_details"
                    label="List equipment needs not covered above:"
                    label-class="['fullWidth']"
                    v-model="$v.form.equipment_other_details.$model"
                    :validator="$v.form.equipment_other_details"
                    error-message="Equipment details are required."
                />
            </div>

            <h3 class="clearfix">Notice</h3>
            <p>
                As a modest way of recognizing our volunteer instructors after completion of a class, you may register for one
                class free of tuition in appreciation for each class previously taught, with no time limit to this tuition "credit."
                Instructors receive no monetary compensation for teaching.
            </p>

            <span class="formNote">Note: You must complete all information before sending this proposal.</span><br>
    <!--
            <button
                v-text="'Send proposal'"
                :disabled="$v.form.$invalid"

                style="margin-top: 1em;"
                class="g-recaptcha"
                data-sitekey="<?= RECAPTCHA_SITEKEY ?>"
                data-callback="myOnSubmit"
            >Send proposal</button>
    -->
            <button
                v-text="'Send proposal'"
                :disabled="$v.form.$invalid || $v.form.$anyError"
                @click.prevent="$refs.recaptcha.execute()"
            />
            <button
                v-text="'Highlight incomplete entries'"
                v-if="$v.form.$invalid || $v.form.$anyError"
                @click.prevent="showErrors"
                class="showErrors"
            />
            <span
                v-if="dev"
                @click="populate"
                v-text="'Populate form for testing'"
                style="display: inline-block; color: blue; margin-left: 2em; cursor: pointer; font-size: 85%;"
            />
            <div class="submissionError" :class="{hidden: status !== 'error'}">
                There was a problem sending your proposal. Please try again later or contact us.
            </div>


            <vue-recaptcha
                :sitekey="recaptchaSitekey"
                @verify="doSubmit"
                size="invisible"
                ref="recaptcha"
            />
        </form>
        <div class="thankYou" :class="{hidden: status !== 'thanks'}">
            <p>
                Thank you! We have received your course proposal. Our office will be in touch with you
                shortly regarding your proposal.
            </p>
        </div>
    </div>
</template>

<script>
import { validationMixin } from 'vuelidate';
import { required, requiredIf, email, numeric } from 'vuelidate/lib/validators'
import AscCheckbox from './AscCheckbox';
import AscRadio from './AscRadio';
import LabelInput from '../../_components/form/LabelInput';
import InputOnly from '../../_components/form/InputOnly';
import { VueRecaptcha } from 'vue-recaptcha';
// import Vue from 'vue';
import VueScrollTo from 'vue-scrollto';
import axios from 'axios';

// Vue.use(VueScrollTo);

function atLeastOneFormatChosen(value) {
    return Object.values(this.form.format).some(val => !!val);
}
function dayTimeRanksValid(value) {
    if (this.form.times_notes) {
        return true;
    }
    let ranks = this.form.day_time_ranks.flat();
    return ranks.filter(rank => rank.trim() !== '').length >= 3
            || this.form.times_notes.trim() !== ''
    ;
}
function classroomRanksValid(value) {
    if (!this.showLocations) {
        return true;
    }

    let pubidsShown = this.classroomRegionsToShow.flatMap(cr => cr.classrooms.map(c => c.pubid));

    let ranksShown = Object.entries(this.form.classroom_ranks)
        .filter(([pubid, rank]) => pubidsShown.includes(pubid))
        .map(([pubid, rank]) => rank)
    ;

    return ranksShown.every(rank => rank.trim().match(/^\d*$/))
        && ranksShown.filter(rank => rank.trim().match(/^\d+$/)).length >= this.nClassroomSelectionsRequired
    ;

    // let ranks = Object.values(this.form.classroom_ranks);
    // return ranks.every(rank => rank.trim().match(/^\d*$/))
    //     && ranks.filter(rank => rank.trim() !== '').length >= 3
    // ;
}

export default {
    components: {
        LabelInput,
        InputOnly,
        AscCheckbox,
        AscRadio,
        VueRecaptcha,
        VueScrollTo,
    },
    mixins: [
        validationMixin,
    ],
    props: {
        intro: {
            type: String,
        },
        terms: {
            type: Array,
        },
        classroomRegions: {
            type: Array,
        },
        onlineOnly: {
            type: Boolean,
            default: false,
        },
        recaptchaSitekey: {
            type: String,
        },
        dev: {
            type: Boolean,
            default: false,
        }
    },
    data() {
        return {
            form: {
                term: '',
                instructor_name: '',
                course_title: '',
                contact: {
                    street: '',
                    city: '',
                    state: '',
                    zip: '',
                    phone_number: '',
                    email_address: '',
                },
                biographical_summary: '',
                course_description: '',
                risks: '',
                format: {
                    small_group_discussion: false,
                    lecture: false,
                    presentation_discussion: false,
                    // online: false,
                    // part_online: false,
                    outdoor: false,
                    other: false,
                },
                presence_mode: '',
                format_description: '',
                field_work: '',
                field_trip_details: '',
                in_person_min: '',
                in_person_max: '',
                online_min: '',
                online_max: '',
                other_instructors: '',
                other_instructor_detail: '',
                number_of_weeks: '',
                date_start: '',
                // days_per_week: '',
                day_time_ranks: [],
                times_notes: '',
                classroom_ranks: {},
                supplies: '',
                required_text: '',
                checked_shermans: '',
                books: [],
                materials_cost: '',
                need_copies: '',
                equipment: {
                    // slide_projector: false,
                    // overhead_projector: false,
                    flip_chart: false,
                    lcd_projector: false,
                    cd_player: false,
                    dvd_player: false,
                    other: false,
                },
                equipment_other_details: '',
            },
            field_work_user: null,
            day_time_rank_classes: [],
            classroom_rank_classes: [],
            status: 'form',
        };
    },
    validations: {
        form: {
            term: { required },
            instructor_name: { required },
            course_title: { required },
            contact: {
                street: { required },
                city: { required },
                state: { required },
                zip: { required },
                phone_number: { required },
                email_address: { required, email },
            },
            biographical_summary: { required },
            course_description: { required },
            risks: { },
            format: {
                small_group_discussion: { atLeastOneFormatChosen },
                lecture: { atLeastOneFormatChosen },
                presentation_discussion: { atLeastOneFormatChosen },
                // online: { atLeastOneFormatChosen },
                // part_online: { atLeastOneFormatChosen },
                outdoor: { atLeastOneFormatChosen },
                other: { atLeastOneFormatChosen },
            },
            presence_mode: { required },
            format_description: { required: requiredIf(form => form.format.other) },
            field_work: { required: requiredIf(form => !form.format.outdoor) },
            field_trip_details: { required: requiredIf(form => form.field_work) },
            in_person_min: { required: requiredIf(form => form.presence_mode === 'in_person' || form.presence_mode === 'hybrid'), numeric },
            in_person_max: { required: requiredIf(form => form.presence_mode === 'in_person' || form.presence_mode === 'hybrid'), numeric },
            online_min: { required: requiredIf(form => form.presence_mode === 'online' || form.presence_mode === 'hybrid'), numeric },
            online_max: { required: requiredIf(form => form.presence_mode === 'online' || form.presence_mode === 'hybrid'), numeric },
            other_instructors: { required },
            other_instructor_detail: { required: requiredIf(form => form.other_instructors) },
            number_of_weeks: { required },
            date_start: { required },
            // days_per_week: { required },
            day_time_ranks: { dayTimeRanksValid },
            times_notes: { dayTimeRanksValid },
            classroom_ranks: { classroomRanksValid },
            supplies: { },
            required_text: { required },
            checked_shermans: { required: requiredIf(form => form.required_text) },
            books: { },
            materials_cost: { required: requiredIf(form => form.supplies || form.required_text) },
            need_copies: { required },
            equipment: {
                // slide_projector: { },
                // overhead_projector: { },
                flip_chart: { },
                lcd_projector: { },
                cd_player: { },
                dvd_player: { },
                other: { },
            },
            equipment_other_details: { required: requiredIf(form => form.equipment.other) },
        },
    },

    computed: {
        showLocations() {
            // return Object.values(this.form.format).filter(val => val).length !== 1
            //     || !this.form.format.online
            // ;
            if (this.form.presence_mode === 'online') {
                return false;
            }
            if (Object.values(this.form.format).filter(val => val).length !== 1) {
                return true;
            }
            if (this.form.format.outdoor) {
                return false;
            }
            return true;
        },

        classroomRegionsToShow() {
            let vue = this;
            return this.classroomRegions.map(region => {
                region = Object.assign({}, region);
                region.classrooms = region.classrooms.filter(classroom => vue.form.presence_mode !== 'hybrid' || classroom.hybrid);
                return region;
            }).filter(region => region.classrooms.length);
        },

        nClassroomSelectionsRequired() {
            let nClassroomsShown = Number(this.classroomRegionsToShow.reduce((acc, region) => acc + region.classrooms.length, 0));
            return Math.min(3, nClassroomsShown);
        },
    },

    watch: {
        'form.format.outdoor': function(cur) {
            if (cur) {
                this.form.field_work = true;
            } else {
                this.form.field_work = this.field_work_user;
            }
        },
    },

    methods: {
        enforceDigitsOnly(evt) {
            if ( (this.controlKeyCodes.indexOf(evt.keyCode) >= 0) || (evt.key.search(/\d/) >= 0) ) {
                return true;
            }
            evt.preventDefault();
        },
        clearDayTimePulse() {
            for (let iDay = 0; iDay < this.days.length; iDay++) {
                for (let iTimeSlot = 0; iTimeSlot < this.timeSlots.length; iTimeSlot++) {
                    this.$set(this.day_time_rank_classes[iDay], iTimeSlot, '');
                }
            }
        },
        clearClassroomPulse() {
            Object.keys(this.classroom_rank_classes).forEach(pubid => {
                this.$set(this.classroom_rank_classes, pubid, '');
            });
        },
        updateDayTimeRanks(iDayChanged, iTimeSlotChanged) {
            this.$v.form.day_time_ranks.$touch();
            this.clearDayTimePulse();
            setTimeout(() => {
                let val = parseInt(this.form.day_time_ranks[iDayChanged][iTimeSlotChanged]);
                let madeAChange;
                do {
                    madeAChange = false;
                    udtrLoop:
                        for (let iDay = 0; iDay < this.days.length; iDay++) {
                            for (let iTimeSlot = 0; iTimeSlot < this.timeSlots.length; iTimeSlot++) {
                                if (iDay == iDayChanged && iTimeSlot == iTimeSlotChanged) {
                                    continue;
                                }
                                if (this.form.day_time_ranks[iDay][iTimeSlot] == val) {
                                    val++;
                                    this.form.day_time_ranks[iDay][iTimeSlot] = val.toString();
                                    this.$set(this.day_time_rank_classes[iDay], iTimeSlot, 'pulse');
                                    iDayChanged = iDay;
                                    iTimeSlotChanged = iTimeSlot;
                                    madeAChange = true;
                                    break udtrLoop;
                                }
                            }
                        }
                } while(madeAChange);
            }, 100);
        },
        updateClassroomRanks(pubidChanged) {
            this.$v.form.classroom_ranks.$touch();
            this.clearClassroomPulse();
            setTimeout(() => {
                let pubids = Object.keys(this.form.classroom_ranks);
                let val = parseInt(this.form.classroom_ranks[pubidChanged]);
                let madeAChange;
                do {
                    madeAChange = false;
                    for (let iClassroom = 0; iClassroom < pubids.length; iClassroom++) {
                        let pubid = pubids[iClassroom];
                        if (pubid == pubidChanged) {
                            continue;
                        }
                        if (this.form.classroom_ranks[pubid] == val) {
                            val++;
                            this.form.classroom_ranks[pubid] = val.toString();
                            this.$set(this.classroom_rank_classes, pubid, 'pulse');
                            pubidChanged = pubid;
                            madeAChange = true;
                            break;
                        }
                    }
                } while(madeAChange);
            }, 100);
        },
        addBook() {
            this.form.books.push(Object.assign({}, this.emptyBook));
        },
        getErrors(obj, path) {
            if (typeof obj.$model !== 'object' || Array.isArray(obj.$model)) {
                return [];
            }
            path = path || '';
            let errors = [];
            let keyPrefix = path ? (path + '.') : '';
            Object.keys(obj.$model).forEach(key => {
                // when using this for html form input, model is never an object
                if (typeof obj[key].$model !== 'object') {
                    if (obj[key].$invalid) {
                        errors.push(keyPrefix + key);
                    }
                    errors.push(...this.getErrors(obj[key], keyPrefix + key));
                }
            });

            return errors;
        },
        showErrors() {
            this.$v.$touch();
            let errors = this.getErrors(this.$v.form);
            if (errors.length) {
                VueScrollTo.scrollTo('#' + errors[0]);
            }
        },
        populate() {
            if (!this.dev) {
                return;
            }
            this.form = Object.assign(this.form, {
                term: this.terms[0].pubid,
                instructor_name: 'Jaime Escalante',
                course_title: 'Algebra',
                contact: {
                    street: '1 Main Street',
                    city: 'Bar Harbor',
                    state: 'ME',
                    zip: '04609',
                    phone_number: '207-555-1212',
                    email_address: 'j.escalante@example.com',
                },
                biographical_summary: 'Born and raised in Bolivia, Jaime Escalante taught school there until he decided to emigrate to America in his mid-\'30s.',
                course_description: 'Algebra 1 topics include recognizing and developing patterns using tables, graphs and equations. In addition, students will explore operations on\n' +
                    'algebraic expressions, apply mathematical properties to algebraic equations. ',
                // risks: '',
                format: {
                    small_group_discussion: false,
                    lecture: true,
                    presentation_discussion: false,
                    // online: false,
                    // part_online: false,
                    outdoor: false,
                    other: false,
                },
                presence_mode: 'in_person',
                // format_description: '',
                field_work: false,
                // field_trip_details: '',
                in_person_min: 5,
                in_person_max: 30,
                other_instructors: false,
                // other_instructor_detail: '',
                number_of_weeks: 8,
                date_start: '2022-12-01',
                // days_per_week: 2,
                day_time_ranks: [['1', ''], ['', '2'], ['3', ''], ['', ''], ['', ''],],
                // times_notes: '',
                classroom_ranks: { bbv: '1', whc: '2', cof: '3', },
                supplies: 'None needed.',
                required_text: false,
                // checked_shermans: true,
                // books: [],
                materials_cost: '$0',
                need_copies: false,
                equipment: {
                    // slide_projector: false,
                    // overhead_projector: false,
                    flip_chart: true,
                    lcd_projector: false,
                    cd_player: false,
                    dvd_player: false,
                    other: false,
                },
                // equipment_other_details: '',
            });
        },
        doSubmit(recaptchaResponse) {
            let vue = this;
            axios.post('/course-proposals/add', {
                form: this.form,
                'g-recaptcha-response': recaptchaResponse,
            })
                .then(response => {
                    vue.status = 'thanks';
                    VueScrollTo.scrollTo('.thankYou');
                })
                .catch(error => {
                    console.error(error);
                    vue.status = 'error';
                    VueScrollTo.scrollTo('.submissionError');
                })
            ;
        },
    },
    created() {
        // backspace, tab, end, home, left arrow, right arrow, delete
        this.controlKeyCodes = [8, 9, 35, 36, 37, 39, 46];

        this.days = ['Mon', 'Tue', 'Wed', 'Thu', 'Fri'];
        this.timeSlots = ['9:30 - 11:30 am', '1:00 - 3:00 pm'];
        this.form.day_time_ranks = [...Array(this.days.length)].map(day => Array(this.timeSlots.length).fill(''));
        this.day_time_rank_classes = [...Array(this.days.length)].map(day => Array(this.timeSlots.length).fill(''));

        this.classroomRegions.forEach(cr => {
            cr.classrooms.forEach(c => {
                this.$set(this.form.classroom_ranks, c.pubid, '');
            });
        });

        this.emptyBook = {
            author: '',
            title: '',
            publisher: '',
            date: '',
            isbn: '',
        };
        this.addBook(); // zzz do only if needed
    },
    mounted() {
        if (this.terms.length) {
            this.form.term = this.terms[0].pubid;
        }
        // this.form.format_online = !!this.onlineOnly;
        this.form.format.online = !!this.onlineOnly;
        // this.$set(this.form.format, 'online', !!this.onlineOnly);
    },
}
</script>

<style lang="scss">
.courseProposalWrapper {
    #courseProposalForm {
        width: 100%;

        @media(max-width: 700px) {
            #term {
                width: 100%;
            }

            #term + fieldset {
                display: flex;
                flex-direction: column;
            }

            div.customRadio {
                white-space: normal;
            }

            .customRadioLabel {
                margin-right: 0;
                width: unset;
                vertical-align: top;
            }

            .termDue {
                display: block;
                margin-left: 0;
                font-style: italic;
            }
        }

    }

    label {
        margin: 0;

        &.fullWidth span {
            @media(max-width: 700px) {
                max-width: calc(100% - 45px);
            }
        }
    }

    .formNote {
        font-style: italic;
        display: inline-block;
        font-size: 90%;
    }

    .customCheckbox input {
        visibility: hidden;
    }

    .days_times td input {
        width: 3em;
    }

    .field-label {
        display: inline-block;
        width: 10em;
        vertical-align: top;

        &.fullWidth {
            display: block;
            width: unset;
        }
    }

    .field-body {
        display: inline-block;
    }
    .control {
        padding: 3px;
        width: 21em;

        .input {
            width: 100%;

            @media(max-width: 700px) {
                width: calc(100% - 45px);
            }
        }
    }
    .help {
        font-size: 80%;
        margin: 0;
    }
    .help.is-danger {
        color: red;
    }
    .state {
        width: 3em !important;
    }
    .zip {
        width: 6em !important;
    }

    @-webkit-keyframes pulse {
        0% {
            box-shadow: inset 0px 0px 2em 1px rgba(214,134,15,1);
        }
        100% {
            box-shadow: none;
        }
    }

    .pulse {
        animation-name: pulse;
        animation-duration: 200ms;
        animation-iteration-count: 1;
        animation-timing-function: ease-in-out;
    }

    .hidden {
        display: none !important;
    }

    .submissionError {
        font-weight: bold;
        color: red;
    }

    .showErrors {
        margin-left: 40px;
        font-size: 80%;

        @media(max-width: 700px) {
            margin-left: 0;
            margin-top: 10px;
        }
    }

    .days_times {
        &.narrow {
            display: none;
        }

        @media(max-width: 700px) {
            &.narrow {
                display: table;
            }
            &.wide {
                display: none;
            }
        }

        th {
            font-size: 1rem;
        }
    }
}
</style>
